/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MuDataProcessingJoinersCountryIntervalDriver
 */
export interface MuDataProcessingJoinersCountryIntervalDriver {
    /**
     * 
     * @type {number}
     * @memberof MuDataProcessingJoinersCountryIntervalDriver
     */
    driverId: number;
}

export function MuDataProcessingJoinersCountryIntervalDriverFromJSON(json: any): MuDataProcessingJoinersCountryIntervalDriver {
    return MuDataProcessingJoinersCountryIntervalDriverFromJSONTyped(json, false);
}

export function MuDataProcessingJoinersCountryIntervalDriverFromJSONTyped(json: any, ignoreDiscriminator: boolean): MuDataProcessingJoinersCountryIntervalDriver {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'driverId': json['driver_id'],
    };
}

export function MuDataProcessingJoinersCountryIntervalDriverToJSON(value?: MuDataProcessingJoinersCountryIntervalDriver | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'driver_id': value.driverId,
    };
}


